/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ShowIf from 'loracoms/ShowIf';
import RichLabel from 'loracoms/RichLabel';
import EditDRModal from '../EditDRModal';
import styles from './styles.scss';


const propTypes = {
  channels: React.PropTypes.array.isRequired,
  reserved: React.PropTypes.array.isRequired,
  dataRates: React.PropTypes.object.isRequired,
  maxChannels: React.PropTypes.number.isRequired,
  onDelete: React.PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  intl: React.PropTypes.object.isRequired,
};

class ChannelsDraft extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      channels: props.channels,
      reserved: props.reserved,
      dataRates: props.dataRates,
      maxChannels: props.maxChannels,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.channelview.add.channels');
    this.handleEditDR = this.handleEditDR.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { channels, reserved, dataRates } = nextProps;
    if (channels !== this.props.channels) {
      this.setState({ channels });
    }
    if (reserved !== this.props.reserved) {
      this.setState({ reserved });
    }
    if (dataRates !== this.props.dataRates) {
      this.setState({ dataRates });
    }
  }

  typeOfChannel(channel) {
    const { dataRates: { lora = [] } = {} } = this.state;
    if (lora.findIndex(dr => dr.dr === channel.mindr) >= 0) {
      return 'LoRa';
    }
    return 'FSK';
  }

  handleEditDR(ch) {
    this.props.onEdit(ch);
  }

  render() {
    const { maxChannels, onDelete } = this.props;
    const {
      channels,
      reserved,
      dataRates,
      showEditModal = false,
      editChannel = {},
    } = this.state;
    return (
      <div>
        <div className={styles.header}>
          {this.intlMsg.msg('header')}
        </div>
        <Table
          className={`aisz-table-light ${channels.length === maxChannels ? styles.full : ''}`}
          bordered
          responsive
        >
          <thead>
            <tr>
              <th className={styles.idx}>#</th>
              <th>{this.intlMsg.msg('id')}</th>
              <th>{this.intlMsg.msg('type')}</th>
              <th>{this.intlMsg.msg('freq')}</th>
              <th>Min DR</th>
              <th>Max DR</th>
              <th>{this.intlMsg.msg('delete')}</th>
              <th>{this.intlMsg.msg('edit')}</th>
            </tr>
          </thead>
          <tbody>
            {reserved.map((ch, idx) => (
              <tr className={styles.reserved} key={ch.id}>
                <td className={styles.idx}>#{idx + 1}</td>
                <td>{ch.id}</td>
                <td><RichLabel content={this.typeOfChannel(ch)} /></td>
                <td>{ch.freq / 1000000}</td>
                <td>{ch.mindr}</td>
                <td>{ch.maxdr}</td>
                <td> {this.intlMsg.msg('reserved')} </td>
                <td>
                  <Link
                    onClick={() => this.setState({
                      showEditModal: true,
                      editChannel: ch,
                    })}
                  >
                    <span className="glyphicon glyphicon-pencil" />
                  </Link>
                </td>
              </tr>
            ))}
            {channels.map((ch, idx) => (
              <tr key={ch.id}>
                <td className={styles.idx}>#{idx + 1}</td>
                <td>{ch.id}</td>
                <td><RichLabel content={this.typeOfChannel(ch)} /></td>
                <td>{ch.freq / 1000000}</td>
                <td>{ch.mindr}</td>
                <td>{ch.maxdr}</td>
                <td>
                  <Link onClick={() => onDelete(ch)}>
                    <span className="halflings halflings-remove text-danger" />
                  </Link>
                </td>
                <td>
                  <Link
                    onClick={() => this.setState({
                      showEditModal: true,
                      editChannel: ch,
                    })}
                  >
                    <span className="glyphicon glyphicon-pencil" />
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <ShowIf if={channels.length === 0}>
          <div className={styles.placeholder}>
            {this.intlMsg.msg('selecttips')}
            <i className={`fa fa-hand-o-left ${styles.pointer}`} />
          </div>
        </ShowIf>
        <EditDRModal
          show={showEditModal}
          onHide={() => this.setState({ showEditModal: false })}
          channel={editChannel}
          dataRates={dataRates}
          onEdit={this.handleEditDR}
        />
      </div>
    );
  }
}

ChannelsDraft.propTypes = propTypes;

export default injectIntl(ChannelsDraft);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/ChannelView/coms/ChannelsDraft/index.jsx